import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function KakobuyVsCssbuy() {
  return <ArticleLayout content={allArticles[1]} />;
}